import { render } from "./OperateInventory.vue?vue&type=template&id=66be9282"
import script from "./OperateInventory.vue?vue&type=script&lang=js"
export * from "./OperateInventory.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__